import { useGetProviderIconUrl } from '../hooks/use-get-provider-icon-url'
import type { BaseIconProps } from './base-provider-icon'
import { BaseProviderIcon } from './base-provider-icon'

/**
 * The Samsara icon component
 */
export const SamsaraIcon = ({ size }: BaseIconProps) => {
  const iconUrl = useGetProviderIconUrl('samsara-logo', 'logo')

  return <BaseProviderIcon size={size} src={iconUrl} label="samsara-icon" />
}
